<div class="container pt-25 lg:pt-30 pb-15 flex flex-col gap-6">
  <!-- 헤더 -->
  <div class="calendar-header flex flex-col gap-6 justify-center">
    <h1 class="text-2xl lg:text-4xl text-center text-zinc-800">
      밀리언쇼 행사 캘린더
    </h1>
    <div class="tabs p-1 lg:p-2 mx-auto min-w-60">
      <button
        class="tab flex flex-1 items-center gap-2"
        [class.active]="activeTab() === 'calendar'"
        (click)="changeTab('calendar')"
      >
        <app-icon name="ic:outline-calendar-month" class="size-5" />
        캘린더형
      </button>
      <button
        class="tab flex flex-1 items-center gap-2"
        [class.active]="activeTab() === 'list'"
        (click)="changeTab('list')"
      >
        <app-icon name="material-symbols:data-table-outline" class="size-5" />
        목록형
      </button>
    </div>
  </div>

  <!-- 캘린더 뷰 -->
  @if (activeTab() === 'calendar') {
  <div class="flex flex-col gap-6">
    <!-- 월 네비게이션 -->
    <div class="flex items-center gap-3 w-full justify-center lg:justify-start">
      <button
        class="cursor-pointer size-5 lg:size-6 rounded-full bg-zinc-300 items-center justify-center flex"
        (click)="prevMonth()"
      >
        <app-icon
          name="material-symbols:arrow-back-ios-new"
          class="size-3! text-white"
        />
      </button>
      <h1 class="text-xl lg:text-2xl text-zinc-800">
        {{ currentMonthText() }}
      </h1>
      <button
        class="cursor-pointer size-5 lg:size-6 rounded-full bg-zinc-300 items-center justify-center flex"
        (click)="nextMonth()"
      >
        <app-icon
          name="material-symbols:arrow-forward-ios"
          class="size-3! text-white"
        />
      </button>
    </div>

    <!-- 캘린더 그리드 -->
    <div class="calendar-grid border border-zinc-100">
      <!-- 요일 헤더 -->
      <div class="weekday-header sun">일</div>
      <div class="weekday-header">월</div>
      <div class="weekday-header">화</div>
      <div class="weekday-header">수</div>
      <div class="weekday-header">목</div>
      <div class="weekday-header">금</div>
      <div class="weekday-header sat">토</div>

      <!-- 날짜 셀 -->
      @for (day of calendarDays(); track day.date.getTime()) {
      <button
        type="button"
        class="calendar-day"
        [class.other-month]="!day.isCurrentMonth"
        [class.today]="day.isToday"
        [class.has-events]="day.events.length > 0"
        (click)="onDateClick(day)"
        [disabled]="day.events.length === 0"
      >
        <div
          class="flex flex-col gap-2 lg:flex-row lg:justify-between items-center"
        >
          <div class="day-number">
            <span>{{ day.day }}</span>
          </div>
          <div>
            @if (day.events.length > 0) {
            <span class="text-xs bg-zinc-100 rounded-sm px-1 text-zinc-500"
              >{{ day.events.length }}건</span
            >
            }
          </div>
        </div>

        <div class="hidden events-list lg:flex flex-col gap-3">
          @for (event of day.events.slice(0, 3); track event.id) {
          <div class="flex flex-col gap-1">
            <div class="flex gap-1">
              <app-icon
                name="material-symbols:check-circle"
                class="size-4! text-secondary-500"
              />
              <p class="text-sm text-zinc-800 sb-aggro font-light">
                {{ event.title }}
              </p>
            </div>
            <p class="text-sm text-zinc-600">{{ event.place.name }}</p>
            <p class="text-xs text-zinc-400">
              {{ formatDateRangeShort(event.startAt, event.endAt) }}
            </p>
          </div>

          } @if (day.events.length > 3) {
          <div class="more-events">+{{ day.events.length - 3 }}개 더보기</div>
          }
        </div>
      </button>
      }
    </div>
  </div>
  }

  <!-- 리스트 뷰 -->
  @if (activeTab() === 'list') {
  <app-calendar-list-component [items]="items()" />
  }
</div>

<!-- 하단 배경 이미지 - 모바일/데스크톱 분리 -->
<img
  src="/bottom-bg.svg"
  alt="bottom-bg"
  class="w-full h-25 object-cover fixed bottom-0 left-0 -z-10 lg:relative lg:h-auto lg:object-contain"
/>
